import { InjectionToken } from '@angular/core';
import { LocalCache } from '@nk/caching-lib';
import {
  CompanyShareholderParams,
  CompanyShareOwnershipUltimateCompositeEntity,
  SimpleCollection,
} from '@nk/data-entities-lib';
import { Observable } from 'rxjs';

// TODO: create CompanyOwnershipService in the company block. Move listed methods there from BusinessService.
export interface CompanyOwnershipApiService {
  companyShareOwnershipUltimateCompositeCollection: LocalCache<
    CompanyOwnershipApiService,
    (params: CompanyShareholderParams) => Observable<SimpleCollection<CompanyShareOwnershipUltimateCompositeEntity>>
  >;
}
export const COMPANY_OWNERSHIP_API_SERVICE_TOKEN = new InjectionToken<CompanyOwnershipApiService>(
  'CompanyOwnershipApiService',
);
